{
  "alert": "警报",
  "dismiss": "取消"
}
